var GREEN_DEALER_PATH_LIST_NAME = 'search dealer';
export default GREEN_DEALER_PATH_LIST_NAME;
